import mutations from "./employabilitySickness.mutations";
import actions from "./employabilitySickness.actions";
import getters from "./employabilitySickness.getters";

import initialState from "./defaultState";

const state = initialState();

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
